export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.045 2.73C.5 3.8.5 5.2.5 8v4c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C4.3 20 5.7 20 8.5 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185c.545-1.07.545-2.47.545-5.27V8c0-2.8 0-4.2-.545-5.27A5 5 0 0017.77.545C16.7 0 15.3 0 12.5 0h-4C5.7 0 4.3 0 3.23.545A5 5 0 001.045 2.73zm7.748 10.477a1 1 0 001.414 0L15.414 8 14 6.586l-4.5 4.5-2.5-2.5L5.586 10l3.207 3.207z"/>
  `,
  title: 'Checkbox Fill',
  viewBox: '0 0 21 20',
};
